module.exports = __webpack_public_path__ + "img/syl_gallery0.ea5fad12.jpg";